import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE } from 'components/Dashboards/Reporting/reportingConfig';

export const finishDateActivitiesPredecessors: IHashmapItemComponentProps = {
    componentKey: 'finishDateActivitiesPredecessors',
    NoPermissionMessage,
    globalFiltersConfig: [{ key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null }],
    reportStyle: {
        widgetSizesAvailable: { large: LARGE, extraLarge: EXTRA_LARGE },
        widgetInitialSize: LARGE,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: false,
        },
        hideNarrativeEditor: false,
    },
};
